import React, { useEffect, useState } from 'react';
import { auth } from '../services/api';
import './Login.css';

// Page de connexion A97 Projets — même gabarit que DATA et BI (identité A97
// validée), étiquette d’application « PROJETS ». Microsoft est le SEUL mode de
// connexion, par construction.
function Login({ authError }) {
  const [error, setError] = useState('');
  const [msLoading, setMsLoading] = useState(false);
  const [config, setConfig] = useState(null);

  useEffect(() => {
    let mounted = true;
    auth.getConfig()
      .then((res) => { if (mounted) setConfig(res.data); })
      .catch(() => { if (mounted) setConfig({ microsoft: false }); });
    return () => { mounted = false; };
  }, []);

  const handleMicrosoft = async () => {
    setError('');
    setMsLoading(true);
    try {
      const res = await auth.microsoftStart();
      window.location.href = res.data.url;
    } catch (err) {
      setError(err.response?.data?.error || 'Connexion Microsoft indisponible');
      setMsLoading(false);
    }
  };

  const displayError = error || authError;

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="login-brand">
          <h1 className="login-mark" aria-label="A97 Projets">
            A<span>97</span>
            <span className="login-mark-app">PROJETS</span>
          </h1>
          <span className="login-subtitle">Gestion de projet</span>
        </div>

        {displayError && (
          <div className="login-error" role="alert">
            <svg viewBox="0 0 20 20" fill="currentColor" width="16" height="16">
              <path fillRule="evenodd" d="M18 10A8 8 0 11 2 10a8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clipRule="evenodd"/>
            </svg>
            <span>{displayError}</span>
          </div>
        )}

        {config && config.microsoft && (
          <>
            <button
              type="button"
              className="login-ms-button"
              onClick={handleMicrosoft}
              disabled={msLoading}
            >
              {msLoading ? (
                <>
                  <span className="spinner" />
                  Redirection vers Microsoft…
                </>
              ) : (
                <>
                  <svg viewBox="0 0 21 21" width="20" height="20" aria-hidden="true">
                    <rect x="1" y="1" width="9" height="9" fill="#f25022" />
                    <rect x="11" y="1" width="9" height="9" fill="#7fba00" />
                    <rect x="1" y="11" width="9" height="9" fill="#00a4ef" />
                    <rect x="11" y="11" width="9" height="9" fill="#ffb900" />
                  </svg>
                  Se connecter avec Microsoft
                </>
              )}
            </button>
            <p className="login-ms-hint">Utilisez votre adresse e-mail professionnelle.</p>
          </>
        )}

        {config && !config.microsoft && (
          <div className="login-pending" role="status">
            La connexion Microsoft est en cours de configuration par le service
            informatique. L'application sera accessible dès que c'est fait.
          </div>
        )}

        <p className="login-legal">Accès réservé au personnel autorisé.</p>
      </div>

      <div className="login-bg-overlay" />
    </div>
  );
}

export default Login;
